import { useAuth } from "@/app/auth-context";

export interface PermissionsApi {
  has: (claim: string) => boolean;
  hasAny: (claims: readonly string[]) => boolean;
  hasAll: (claims: readonly string[]) => boolean;
}

export function usePermissions(): PermissionsApi {
  const { permissions } = useAuth();
  return {
    has: (claim) => permissions.has(claim),
    hasAny: (xs) => xs.some((c) => permissions.has(c)),
    hasAll: (xs) => xs.every((c) => permissions.has(c)),
  };
}
